import { render, staticRenderFns } from "./ImageViewerSwitchComponent.vue?vue&type=template&id=f814216e&scoped=true&"
import script from "./ImageViewerSwitchComponent.vue?vue&type=script&lang=js&"
export * from "./ImageViewerSwitchComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f814216e",
  null
  
)

export default component.exports